import React, { useState } from "react";
import { Eye, EyeOff, Lock, Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import toast from "react-hot-toast";

const AdminSigninPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(form.email, form.password);
      navigate("/admin");
    } catch (err) {
      toast.error(err.cleanMessage || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#04160a] flex items-center justify-center px-6">
      <div className="absolute inset-0 bg-gradient-to-br from-[#04160a] via-[#0b6b1d] to-[#ff6600] opacity-90" />

      <form
        onSubmit={submit}
        className="relative w-full max-w-md bg-white rounded-[34px] shadow-2xl p-8"
      >
        <div className="mb-8 text-center">
          <img
            src="/assets/images/logo.png"
            alt="Logo"
            className="w-20 h-20 mx-auto object-contain mb-4"
          />

          <h1 className="text-3xl font-black text-[#0b6b1d]">
            Admin Sign In
          </h1>

          <p className="text-slate-500 text-sm mt-2">
            Akwa Ibom State Universal Education Board CMS
          </p>
        </div>

        <label className="block mb-4">
          <span className="text-sm font-bold text-slate-700">Email</span>
          <div className="mt-2 flex items-center gap-3 border rounded-2xl px-4 py-3">
            <Mail size={18} className="text-slate-400" />
            <input
              type="email"
              required
              value={form.email}
              onChange={(e) =>
                setForm({ ...form, email: e.target.value })
              }
              className="w-full outline-none"
              placeholder="admin@aksubeb.gov.ng"
            />
          </div>
        </label>

        <label className="block mb-6">
          <span className="text-sm font-bold text-slate-700">Password</span>
          <div className="mt-2 flex items-center gap-3 border rounded-2xl px-4 py-3">
            <Lock size={18} className="text-slate-400" />
            <input
              type={show ? "text" : "password"}
              required
              value={form.password}
              onChange={(e) =>
                setForm({ ...form, password: e.target.value })
              }
              className="w-full outline-none"
              placeholder="Password"
            />

            <button
              type="button"
              onClick={() => setShow(!show)}
              className="text-slate-400"
            >
              {show ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </label>

        <button
          disabled={loading}
          className="w-full py-4 rounded-2xl bg-[#0b6b1d] hover:bg-[#ff6600] text-white font-black transition-colors disabled:opacity-60"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </main>
  );
};

export default AdminSigninPage;